import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { CornerDownRight } from "lucide-react";

interface InfoRowProps {
  label: ReactNode;
  value: ReactNode;
  isHighlighted?: boolean;
  isNumeric?: boolean;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  description?: {
    label?: ReactNode;
    value?: ReactNode;
  };
  descriptionClassName?: string;
}

export function InfoRow({
  label,
  value,
  isHighlighted = false,
  isNumeric = false,
  className,
  labelClassName,
  valueClassName,
  description,
  descriptionClassName,
}: InfoRowProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <div className="flex justify-between">
        <span
          aria-label={label as string}
          className={cn(
            isHighlighted ? "font-medium" : "text-muted-foreground",
            labelClassName
          )}
        >
          {label}
        </span>

        <span
          aria-label={value as string}
          className={cn(
            isHighlighted ? "font-semibold" : "font-medium",
            isNumeric && "tabular-nums",
            valueClassName
          )}
        >
          {value}
        </span>
      </div>

      {description && (
        <div
          className={cn(
            "flex justify-between text-xs text-muted-foreground mt-1",
            descriptionClassName
          )}
        >
          <div className="flex items-center">
            <CornerDownRight size={12} className="mr-1 self-start" />
            <span aria-label={description.label as string}>
              {description.label}
            </span>
          </div>

          {description.value && (
            <span
              aria-label={description.value as string}
              className={cn(isNumeric && "tabular-nums")}
            >
              {description.value}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
